module.exports = "/images/collect-customer-data.svg?649453ebc844e6ecc3485a368243a40d";